import React, { ReactNode, useCallback, useImperativeHandle, useRef } from 'react'

const defaultOptions = {
  wrapCSS: 'tx-lightbox tx-lightbox-inline',
  scrollOutside: false,
  padding: 0,
  parent: 'main',
  mouseWheel: false,
  openEffect: 'none',
  closeEffect: 'none',
  beforeClose: () => {
    $('.bootstrap-select.open').removeClass('open')
  }
}

export type ModalRef = { show: () => void }
export type ModalProps = {
  children?: ReactNode
}

const Modal = React.forwardRef<ModalRef, ModalProps>(function Modal({ children }, ref) {
  const contentRef = useRef<HTMLDivElement>(null)

  const show = useCallback(() => {
    if (contentRef.current) {
      $.fancybox.open(contentRef.current, defaultOptions)
    }
  }, [])

  useImperativeHandle(
    ref,
    () => ({
      show
    }),
    [show]
  )

  return (
    <div style={{ display: 'none' }}>
      <div ref={contentRef} className="tx-lightbox-inline__content">
        {children}
      </div>
    </div>
  )
})

export default Modal
